import React from "react";
import { ArrowLeft, Mail, MessageSquare, ChevronRight } from "lucide-react";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";
import FeatureHeader from "../components/FeatureHeader";
export default function ForgotPasswordOptions({ onBack, onSelectOption }) {

  const navigate = useNavigate()
  return (
  <div style={{ minHeight: "100vh",  background: "var(--bg)", position: "relative" }}>
     <FeatureHeader title = "Forgot Password" subtitle = "Please select the following options to reset your password" onBack={navigate("/signin")} />

      {/* Card */}
      <div style={{  width : "70%", marginLeft : "15%",  borderRadius: "22px", background: "#fff", border: "1px solid #ececf5", boxShadow: "0 12px 36px rgba(80, 0, 200, 0.09)", padding: "32px 28px", textAlign: "center" }}>
        {/* Logo & Title */}
        <div className="mb-4">
          <div style = {{width : "20%", marginLeft : "40% "}}>
          <img src={logo} alt="Logo" style={{ width: "64px" }} />
          </div>
          <h5 className="mt-3 fw-semibold" style={{ color: "#171b2d", fontSize: "22px" }}>Forgot Password</h5>
          <p style={{ color: "#73798a", fontSize: "0.9em", lineHeight: 1.5 }}>
           Please select the following options to reset your password
          </p>
        </div>

        {/* Buttons */}
        <div className="d-flex flex-column gap-3 mt-4">
          {/* Send via Email */}
          <button onClick={() => {navigate("/forgot-reset")}} className="btn d-flex justify-content-between align-items-center px-4 py-3" style={{ borderRadius: "12px", border: "1px solid #e6e2f8", background: "#faf9ff", color: "#272b3d", boxShadow: "none" }}>
            <div className="d-flex align-items-center gap-3">
              <Mail size={20} color="var(--primary)" />
              <span className="fw-semibold" >Send via Email</span>
            </div>
            <ChevronRight size={18} color="var(--primary)" />
          </button>

          {/* Send via SMS */}
          <button onClick={() => typeof onSelectOption === 'function' ? onSelectOption("sms") : window.alert('SMS password recovery is not available yet. Please use email.')} className="btn d-flex justify-content-between align-items-center px-4 py-3" style={{ borderRadius: "12px", border: "1px solid #e6e2f8", background: "#faf9ff", color: "#272b3d", boxShadow: "none" }}>
            <div className="d-flex align-items-center gap-3">
              <MessageSquare size={20} color="var(--primary)" />
              <span className="fw-semibold">Send via SMS</span>
            </div>
            <ChevronRight size={18} color="var(--primary)" />
          </button>
        </div>
      </div>
    </div>
  );
}
